import { getGuid } from 'owa-guid';
import InlineTranslationStore from './schema/InlineTranslationStore';

const store: InlineTranslationStore = {
    sessionId: getGuid(),
    isUserLocaleSupported: false,
    userLanguageName: null,
    localeOfSupportedLanguageMap: null,
    supportedLanguageMap: null,
};

export default store;
